import { Check, Repeat2, X } from 'lucide-react';
import { DialogClose, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ModalId, useCloseModal, useCurrentModalProps } from '@/hooks/data/modal/useModalStore';
import { useUploadStore } from '@/hooks/data/inspector/useUploadStore';
import { Modal, ModalContent } from '@/components/ui/modal';
import { Button } from '@/components/ui/button';
import { useTranslations } from 'next-intl';

export const CsvDialog = () => {
  const tCommon = useTranslations('common');
  const tDialogs = useTranslations('dialogs');

  const modalProps = useCurrentModalProps(ModalId.Csv);
  const closeModal = useCloseModal();
  const { getActiveUploadSession, setCsvData, setCsvFileName } = useUploadStore();
  const { uploadSessionId } = getActiveUploadSession();
  if (!modalProps) {
    return null;
  }
  const { keep, overwrite, originalCsvData, text } = modalProps;

  return (
    <Modal
      id={ModalId.Csv}
      onOpenChange={() => {
        setCsvData(uploadSessionId, originalCsvData);
        setCsvFileName(uploadSessionId, '');
      }}
    >
      <ModalContent>
        <DialogHeader>
          <DialogTitle>{tDialogs('overwriteMetadataTitle')}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="px-3 py-6">{text}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="secondary" data-cy="csv-dialog-dismiss" type="button" icon={X}>
              {tCommon('cancel')}
            </Button>
          </DialogClose>
          <Button
            autoFocus
            onClick={() => {
              overwrite();
              closeModal(ModalId.Csv);
            }}
            data-cy="csv-dialog-overwrite"
            variant="warning"
            icon={Repeat2}
          >
            {tCommon('overwrite')}
          </Button>
          <Button
            onClick={() => {
              keep();
              closeModal(ModalId.Csv);
            }}
            data-cy="csv-dialog-keep"
            variant="info"
            icon={Check}
          >
            {tCommon('keep')}
          </Button>
        </DialogFooter>
      </ModalContent>
    </Modal>
  );
};
